/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.formatter

import studio.oddpods.cauce.core.model.reminder.PendingReminder
import studio.oddpods.cauce.core.model.reminder.ReminderTemplate.PLACEHOLDER_AMOUNT_OWED
import studio.oddpods.cauce.core.model.reminder.ReminderTemplate.PLACEHOLDER_PATIENT_NAME
import studio.oddpods.cauce.core.model.reminder.ReminderTemplate.PLACEHOLDER_SESSION_COUNT
import studio.oddpods.cauce.core.model.reminder.ReminderTemplate.PLACEHOLDER_SESSION_DATES

class RenderMessageTemplateUseCase(
    private val currencyFormatter: CurrencyFormatter,
    private val dateFormatter: DateFormatter,
) {
    fun invoke(template: String, patient: PendingReminder): String {
        val dates = patient.dueSessions
            .mapNotNull { dateFormatter.format(it.sessionDate) }
            .joinToString(", ")
        return template
            .replace(PLACEHOLDER_PATIENT_NAME, patient.patientName)
            .replace(PLACEHOLDER_AMOUNT_OWED, currencyFormatter.format(patient.totalOwed))
            .replace(PLACEHOLDER_SESSION_COUNT, patient.dueSessions.size.toString())
            .replace(PLACEHOLDER_SESSION_DATES, dates)
    }
}
